// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { StreamActions } from "@hotwired/turbo"
import Chart from 'chart.js/auto';

// Make Chart globally available

console.log("Application.js loaded")
console.log("Chart.js version:", Chart.version)


function clearErrors(errorSelector) {
  const errorDiv = document.querySelector(errorSelector);
  const errorList = errorDiv?.querySelector("ul");
  if (errorList) {
    errorDiv.removeChild(errorList);
  }
}

function handleDialog(message, element) {
  let dialog;
  switch (element.id || message) {
    case "apply-fee":
      dialog = document.getElementById("turbo-apply-fee");
      break;
    case "delete-fee":
      dialog = document.getElementById("turbo-delete-fee");
      break;
    case "creating-category":
      dialog = document.getElementById("turbo-create-category");
      document.getElementById("row-category-material-name").value = "";
      clearErrors(".row-category-material-errors");
      break;
    case "creating-category-product":
      dialog = document.getElementById("turbo-create-category-product");
      document.getElementById("category-product-name").value = "";
      clearErrors(".category-product-errors");
      break;
    case "editing-category-product":
      dialog = document.getElementById("turbo-edit-category-product");
      clearErrors(".category-product-errors");
      break;
    case "editing-category":
      dialog = document.getElementById("turbo-edit-category");
      clearErrors(".row-category-material-errors");
      break;
    case "create row material":
      dialog = document.getElementById("add-row-material");
      break;
    case "find-invoices":
      dialog = document.getElementById("find-invoices");
      break;
    case "upload-invoices":
      dialog = document.getElementById("upload-invoices");
      break;
    case "vary-category-price":
      dialog = document.getElementById("turbo-vary-category-price");
      break;
    default:
      return null;
  }
  return dialog;
}

Turbo.setConfirmMethod((message, element) => {
  const select = document.getElementById("product_row_material_row_material_id");
  if (select) {

  setTimeout(() => {
    document.getElementById("product_row_material_row_material_id").tomselect.close() 
  }, 50);
  }

  const select2 = document.getElementById("category_price_row_material_id");
  if (select2) {

  setTimeout(() => {
    document.getElementById("category_price_row_material_id").tomselect.close() 
  }, 50);
  }
  console.log("Custom confirm method called");
  console.log("Message:", message);
  const dialog = handleDialog(message, element);

  if (!dialog) return Promise.resolve(window.confirm(message));
  dialog.showModal();

  return new Promise((resolve) => {
    dialog.addEventListener(
      "close",
      () => {
        resolve(dialog.returnValue === "confirm");
      },
      { once: true }
    );
  });
});

// Modal forms submit scoped to the "modal" frame so validation errors re-render
// in place. On success the controller redirects to another page, which has no
// matching "modal" frame in its response — fall back to a full page visit so
// the redirect, flash notice, and updated list still work as expected.
document.addEventListener("turbo:frame-missing", (event) => {
  const { response, visit } = event.detail;
  event.preventDefault();
  visit(response);
});

document.addEventListener("turbo:frame-load", (event) => {
  const select_category_product = document.getElementById("category_product_id");
  if (select_category_product) {
    new TomSelect(select_category_product,{
      sortField: {
        field: "text",
        direction: "asc"
      },
      maxOptions: null
    });
  }

  const select_category_row_material = document.getElementById("category_row_material_id");

  if (select_category_row_material) {
    new TomSelect(select_category_row_material,{
      sortField: {
        field: "text",
        direction: "asc"
      },
      maxOptions: null
    });
  }
});

document.addEventListener("turbo:submit-start", (event) => {
  if (event.detail.formSubmission.submitter) {
    console.log("Turbo submit start event triggeredaa");
    event.detail.formSubmission.submitter.disabled = true
    event.detail.formSubmission.submitter.classList.add("bg-gray-400")
    event.detail.formSubmission.submitter.value = "Guardando..."
  }
});

document.addEventListener("turbo:submit-end", (event) => {
  if (event.detail.formSubmission.submitter) {
    event.detail.formSubmission.submitter.disabled = false
    event.detail.formSubmission.submitter.classList.remove("bg-gray-400")
    event.detail.formSubmission.submitter.value = "Editar"
    let id = event.detail.formSubmission.submitter.id;
    if (id === "vary-category-price") {
      const dialog = document.getElementById("turbo-vary-category-price");
      if (dialog) {
        dialog.close();
      }
    }
  }
});



function handleModalAction(dialogId, action) {
  const dialog = document.getElementById(dialogId);
  if (dialog) {
    action === "close" ? dialog.close() : dialog.showModal();
  }
}

StreamActions.initialize_tom_tomselect = () => {
  new TomSelect("#category_row_material_id",{
      sortField: {
        field: "text",
        direction: "asc"
      },
      maxOptions: null
  });

  new TomSelect("#category_price_row_material_id",{
      sortField: {
        field: "text",
        direction: "asc"
      },
      maxOptions: null
  });
}
StreamActions.handle_modal = () => handleModalAction("turbo-create-category", "close");
StreamActions.handle_modal_failure = () => handleModalAction("turbo-create-category", "show");
StreamActions.handle_modal_update = () => handleModalAction("turbo-edit-category", "close");
StreamActions.handle_modal_failure_update = () => handleModalAction("turbo-edit-category", "show");
StreamActions.handle_modal_product = () => handleModalAction("turbo-create-category-product", "close");
StreamActions.handle_modal_failure_product = () => handleModalAction("turbo-create-category-product", "show");
StreamActions.handle_modal_failure_update_product = () => handleModalAction("turbo-edit-category_product", "show");
StreamActions.handle_modal_update = function () {
  handleModalAction("turbo-edit-category", "close");
  new TomSelect("#category_row_material_id",{
      sortField: {
        field: "text",
        direction: "asc"
      },
      maxOptions: null
  });
}
StreamActions.handle_modal_update_product = function () {
  handleModalAction("turbo-edit-category-product", "close");
  new TomSelect("#category_product_id",{
      sortField: {
        field: "text",
        direction: "asc"
      },
      maxOptions: null
  });
}
